<template>
  <div class="p-6 my-3 bg-primary-300 stack rounded" v-if="survey">
    <div class="mx-auto text-5xl mb-2">
      <icon name="WaldigLogo" :settings="{ circle: true, strokeWidth: 1 }" />
    </div>
    <div class="text-center" v-if="survey.status !== 'pending'">
      <p class="text-sm mb-4">{{ $t("surveys.survey_finished") }}</p>
      <div class="w-1/2 mx-auto border-t border-black my-2" />
      <p class="text-lg mt-4">{{ survey.question }}</p>
      <div class="my-4 stack-lg" v-if="options.length > 0">
        <div v-for="option in options" :key="option.id">
          <div class="text-sm text-left">
            <span class="mr-1 font-medium">{{ getOptionEntriesCount(option.id) }}%</span>
            {{ option.text }}
          </div>
          <div class="w-full">
            <progress-bar :amount="getOptionEntriesCount(option.id)" css="bg-black" />
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-else-if="survey.voted">
      <h2 class="mb-1">{{ $t("general.thanks") }}</h2>
      <p class="text-sm mb-4">{{ $t("surveys.already_voted") }}</p>
      <div class="w-1/2 mx-auto border-t border-black my-2" />
      <p class="text-lg mt-4">{{ survey.question }}</p>
      <div class="my-4 stack-lg" v-if="options.length > 0">
        <div v-for="option in options" :key="option.id">
          <div class="text-sm text-left">
            <span class="mr-1 font-medium">{{ getOptionEntriesCount(option.id) }}%</span>
            {{ option.text }}
          </div>
          <div class="w-full">
            <progress-bar :amount="getOptionEntriesCount(option.id)" css="bg-black" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p
        class="text-center text-sm italic text-primary-700 mb-4"
      >{{ this.$t(`surveys.types.${survey.type}`) }}</p>
      <p class="text-lg">{{ survey.question }}</p>
      <div v-if="formData.options && options.length > 0">
        <survey-option
          v-for="option in options"
          :key="option.id"
          :option="option"
          @selection="updateOptions(option.id, $event)"
          :selected-array="formData.options"
        />
      </div>
      <div class="text-right mt-4">
        <wd-button black @input="submit(formOptions)">Abschicken</wd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Survey } from "@/modules/surveys/viewmodels/Survey";
import DateMixin from "@/mixins/DateMixin";
import FormMixin from "@/mixins/FormMixin";

const SurveyOption = require("@/modules/surveys/components/SurveyOption.vue")
  .default;
const ProgressBar = require("@/modules/core/components/ProgressBar.vue")
  .default;

export default {
  name: "Survey",
  mixins: [DateMixin, FormMixin],
  data() {
    return {
      optionEntries: null
    };
  },
  props: {
    surveyId: {
      type: String,
      required: true
    },
    select: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SurveyOption,
    ProgressBar
  },
  methods: {
    updateOptions(OptionId, Bool) {
      if (Bool === true) {
        if (this.survey.type === "single") {
          this.$set(this.formData, "options", [OptionId]);
        } else {
          this.formData.options.push(OptionId);
        }
      } else {
        this.$set(
          this.formData,
          "options",
          this.formData.options.filter(e => e !== OptionId)
        );
      }
    },
    getOptionEntriesCount(Id) {
      return this.optionEntries && this.optionEntries.length > 0
        ? Math.round(
            (this.optionEntries.filter(e => e.survey_option_id === Id).length /
              this.optionEntries.length) *
              100
          )
        : 0;
    }
  },
  computed: {
    options() {
      return this.$store.getters["surveyoption/surveyOptionsOfSurvey"](
        this.surveyId
      );
    },
    survey() {
      return this.$store.getters["survey/survey"](this.surveyId);
    }
  },
  async created() {
    await this.$store.getters["survey/api"].Show(this.surveyId, false);
    await this.$store.getters["surveyoption/api"].Custom.ShowOptionsOfSurvey(
      this.surveyId
    );

    this.optionEntries = await this.$store.getters[
      "surveyoptionentry/api"
    ].Custom.OptionEntries(this.surveyId);

    this.$set(this.formData, "options", []);

    this.formOptions = {
      async: true,
      type: "surveyoptionentry",
      call: "create",
      action: async response => {
        this.$store.dispatch("survey/setVoted", this.surveyId);
        this.optionEntries = await this.$store.getters[
          "surveyoptionentry/api"
        ].Custom.OptionEntries(this.surveyId);
        this.popup({
          title: this.$t("surveys.voted"),
          text: this.$t("surveys.voted_message"),
          autohide: true
        });
      }
    };
  }
};
</script>
